var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgThinking1 = function SvgThinking1(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32780_38076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35Z",
    fill: "#E2E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 17.5006C35 27.1693 27.1633 35.0006 17.5 35.0006C11.9985 35.0006 7.08751 32.4631 3.87736 28.4873C6.8797 30.9154 10.7024 32.3646 14.8641 32.3646C24.5274 32.3646 32.3641 24.5334 32.3641 14.8646C32.3641 10.7029 30.9149 6.88027 28.4867 3.87793C32.457 7.08809 35 11.999 35 17.5006Z",
    fill: "#CBD6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3334 25.4386C23.3334 26.1916 22.3793 26.8045 21.2072 26.8045H13.7929C12.6207 26.8045 11.6667 26.1916 11.6667 25.4386C11.6667 24.6856 12.6207 24.0728 13.7929 24.0728H21.2072C22.3793 24.0728 23.3334 24.6865 23.3334 25.4386Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.35 13.4682C14.35 15.6251 13.0124 17.3805 11.3538 17.3805C9.69637 17.3805 8.35765 15.6251 8.35765 13.4682C8.35765 11.3113 9.69527 9.56787 11.3538 9.56787C13.0113 9.56787 14.35 11.3113 14.35 13.4682Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1036 12.3736C12.8596 12.5278 12.4529 12.3572 12.221 11.97C11.9891 11.5938 12.0198 11.1705 12.2748 11.0174C12.5188 10.862 12.9134 11.0447 13.1343 11.4199C13.3783 11.7961 13.3597 12.2194 13.1036 12.3736Z",
    fill: "#5A5F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8139 13.4682C26.8139 15.6251 25.4763 17.3805 23.8177 17.3805C22.1603 17.3805 20.8215 15.6251 20.8215 13.4682C20.8215 11.3113 22.1592 9.56787 23.8177 9.56787C25.4752 9.56787 26.8139 11.3113 26.8139 13.4682Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5686 12.3736C25.3246 12.5278 24.9179 12.3572 24.686 11.97C24.4541 11.5938 24.4837 11.1705 24.7398 11.0174C24.9838 10.862 25.3784 11.0447 25.5993 11.4199C25.8422 11.7961 25.8236 12.2194 25.5686 12.3736Z",
    fill: "#5A5F63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32780_38076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThinking1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thinking1.491431b8.svg";
export { ForwardRef as ReactComponent };